import { render, staticRenderFns } from "./billmeasure.vue?vue&type=template&id=54c3a8ba&scoped=true"
import script from "./billmeasure.vue?vue&type=script&lang=js"
export * from "./billmeasure.vue?vue&type=script&lang=js"
import style0 from "./billmeasure.vue?vue&type=style&index=0&id=54c3a8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3a8ba",
  null
  
)

export default component.exports